
    import { computed, defineComponent } from 'vue'

    import { useGdprStore } from '@/app/stores/gdpr'
    import { useGtag } from '@/common/composables/libs/gtag'
    import { useVuetify } from '@/common/composables/libs/vuetify'

    export default defineComponent({
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        emits: [
            'closed'
        ],
        setup (props, { emit }) {
            const gtag = useGtag()
            const vuetify = useVuetify()
            const gdprStore = useGdprStore()

            const maxWidth = computed(() => {
                switch (vuetify.breakpoint.name) {
                    case 'xs': return '90%'
                    case 'sm': return '80%'
                    case 'md': return '70%'
                    case 'lg': return '60%'
                    default: return '50%'
                }
            })

            const accept = (): void => {
                gdprStore.accept()
                gtag.optIn()
                emit('closed')
            }

            const askLater = (): void => {
                gdprStore.askLater()
                emit('closed')
            }

            const reject = (): void => {
                gdprStore.reject()
                emit('closed')
            }

            return {
                maxWidth,
                accept,
                askLater,
                reject
            }
        }
    })
